import React from "react";
import * as FaIcons from "react-icons/fa";
import styles from "./OurStory.module.css";
import commonStyles from "../../../Components/Shared/commonStyles.module.css";
import CollapseModern from "../../../Components/Shared/Collapsable/CollapseModern";
import usePartnersStore from "../../../Stores/usePartnersStore";
import PartnerCard from "../../../Components/CustomerServices/OurStory/PartnerCard";
import Spinner from "../../../Components/Shared/Spinner/Spinner";
import CallToAction from "../../../Components/Shared/CallToAction/CallToAction";
function OurStory() {
  const { getPartners, partners, loading } = usePartnersStore();

  const handlePartnershipOpened = async (opened) => {
    await getPartners();
  };

  return (
    <div>
      {/* {loading && <Spinner />} */}
      <div className={commonStyles.section}>
        <div className={commonStyles.container}>
          <div className={commonStyles.sectionHeaderContainer}>
            <h2 className={commonStyles.sectionHeader}>Our Story</h2>
            <p className={commonStyles.paragraph}>
              At Match Hampers, our mission has always been simple: to make
              gifting meaningful, effortless, and personal for loved ones in
              Jersey. We believe every gift should bring joy - not just to the
              recipient, but to the sender as well.
            </p>
          </div>
        </div>
      </div>
      <div className={`${styles.spreadJoyContainer}`}>
        <div className={commonStyles.section}>
          <div className={commonStyles.container}>
            <q className={styles.spreadJoyQuote}>
              Spread joy, one gift at a time.
            </q>
          </div>
        </div>
      </div>
      <div className={commonStyles.section}>
        <div className={`${commonStyles.container} ${styles.collapsables}`}>
          <CollapseModern key="gifts-that-delight" title="GIFTS MADE PERSONAL">
            <div className={styles.StoryItemContainer}>
              <div className={styles.block}>
                <p className={commonStyles.paragraph}>
                  Gifting should feel personal, thoughtful and enjoyable, not
                  stressful. It should be about choosing something your loved
                  one will genuinely enjoy and use, without running around town
                  or wondering where you put the sellotape.
                </p>
                <p className={commonStyles.paragraph}>
                  We take the thinking, time and stress out of gift buying,
                  creating personalised gifts and hampers. Whether it's a
                  wedding, birthday, new baby, new home, new hobby or heading
                  off to university, we will help you find the right gifts,
                  bring them together and take care of the finishing touches.
                </p>
                <p>
                  The best gifts are the o nes that make someone think, "You
                  know me really well."
                </p>
              </div>
              <img
                className={styles.giftImage}
                src="/Images/Content/CustomerServices/OurStory/Gifts.jpg"
                alt="Gifts"
              />
            </div>
          </CollapseModern>

          <CollapseModern key="our-journey" title="HOW IT ALL BEGAN">
            <div className={styles.StoryItemContainer}>
              <div className={styles.block}>
                <p className={commonStyles.paragraph}>
                  Match Hampers started with a simple idea: we loved the thought
                  of giving a collection of gifts, so the hampers came first. We
                  started thinking beyond the traditional wicker basket too,
                  looking for ways to make each gift feel more personal and
                  useful.
                </p>
                <p className={commonStyles.paragraph}>
                  One thing was always a definite. If we were going to create a
                  gifting business, personalisation had to be part of it. We
                  bought our first personalisation machine before launching the
                  business in 2021. From there, the business evolved with new
                  products, new ideas and eventually, our embroidery machine.
                </p>
                <p className={commonStyles.paragraph}>
                  In 2024, Match Hampers moved to Jersey. A new home brought new
                  customers, new ideas and an opportunity to refine what we
                  offered.
                </p>
                <p className={commonStyles.paragraph}>
                  Now, our hamper collections have grown, our range has evolved,
                  and we've launched a brand-new website. We're passionate about
                  making it easier for you to find the right gift for the right
                  occasion.
                </p>
              </div>
              <img
                className={styles.giftImage}
                src="/Images/Content/CustomerServices/OurStory/Corporate.jpg"
                alt="Our Journey"
              />
            </div>
          </CollapseModern>

          <CollapseModern
            key="Meet-the-Team"
            title="MEET THE GIFTING CONCIERGE"
          >
            <div className={styles.StoryItemContainer}>
              <div className={styles.block}>
                <p className={commonStyles.paragraph}>
                  Hannah Chevalier-Taylor, Gifting Concierge Director
                </p>
                <p className={commonStyles.paragraph}>
                  Hannah wears many hats at Match Hampers: customer experience,
                  sales, buying, photography, personalisation, branding,
                  marketing… and plenty more besides.
                </p>
                <p className={commonStyles.paragraph}>
                  Her passion is creating meaningful experiences through
                  thoughtful gifts, beautiful presentation and heartfelt
                  messages. She makes sure every gift feels as personal as the
                  person receiving it.
                </p>
                <p className={commonStyles.paragraph}>
                  Before launching Match Hampers, Hannah taught in primary
                  schools across Jersey, where one quote in particular has
                  always stayed with her:
                </p>

                <p className={`${commonStyles.paragraph} ${styles.quote}`}>
                  <q>
                    They don’t care what you know, until they know that you
                    care.
                  </q>
                </p>
                <p className={commonStyles.paragraph}>
                  Two very important team members also help behind the scenes.
                  They help with orders and deliveries, provide plenty of moral
                  support, and you might even meet them at one of our pop-up
                  events.
                </p>

                <p
                  className={
                    `${commonStyles.paragraph}` +
                    ` ${styles.photographerCredit}`
                  }
                >
                  <a
                    href="https://philcolebornphotography.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Photograph by Phil Coleborn Photography
                  </a>
                </p>
              </div>

              <img
                className={`${styles.giftImage}`}
                src="/Images/Content/CustomerServices/OurStory/Hannah.jpeg"
                alt="Hannah"
              />
            </div>
          </CollapseModern>
          <CollapseModern key="our-values" title="WHAT MATTERS TO US">
            <div className={styles.StoryItemContainer}>
              <div>
                <p className={commonStyles.paragraph}>
                  Thoughtful, not generic
                </p>
                <p className={commonStyles.paragraph}>
                  We believe the best gifts are chosen with the recipient in
                  mind. Every gift should feel considered, personal and
                  meaningful.
                </p>
                <p className={commonStyles.paragraph}>
                  Useful, not unnecessary
                </p>
                <p className={commonStyles.paragraph}>
                  We choose products that people will genuinely enjoy and use, because a great gift shouldn't end up at the back of a
                  cupboard.
                </p>
                <p className={commonStyles.paragraph}>
                  Personal, not mass-produced
                </p>
                <p className={commonStyles.paragraph}>
                  From personalised details to carefully chosen combinations, we
                  believe gifts should feel like they were made for one person,
                  not everyone.
                </p>
                <p className={commonStyles.paragraph}>Quality, not quantity</p>
                <p className={commonStyles.paragraph}>
                  We'd rather offer fewer, better products that we're proud to
                  put into a Match Hampers gift.
                </p>
              </div>
              <img
                className={styles.giftImage}
                src="/Images/Content/CustomerServices/OurStory/EmbroideryMachine.jpg"
                alt="Embroidery Machine"
              />
            </div>
          </CollapseModern>
          <CollapseModern
            key="Partnerships"
            title="PARTNERSHIPS"
            onOpen={handlePartnershipOpened}
          >
            <p className={commonStyles.paragraph}>
              We proudly collaborate with local Jersey businesses and trusted
              British brands, sourcing products that make each hamper unique and
              high-quality. Our partners help us elevate every hamper.
            </p>
            <div className={styles.PartnersContainer}>
              <div className={`${commonStyles.cards4} ${styles.cards4}`}>
                {partners.map((partner, index) => (
                  <PartnerCard
                    key={index}
                    name={partner.Name}
                    logo={partner.Img.src}
                    detailsLIst={partner.Details}
                    website={partner.Link.href}
                    linkText={partner.Link.text}
                  />
                ))}
              </div>
            </div>
          </CollapseModern>
        </div>
      </div>
      <CallToAction />
    </div>
  );
}

export default OurStory;
